import React, { MutableRefObject, useRef } from 'react';
import Input from '../../components/forms/Input';
import AuthorsService from '@/common/API/AuthorsService';
import FormFactory from '@/components/FormFactory';
import { Button } from '@/components/ui/button';
import { Field } from 'formik';
import TagsService from '@/common/API/TagsService';
import { Params, useNavigate, useParams } from 'react-router';
import Screen from '@/components/layout/Screen';
import Toast from '@/common/Toast';
import { useData } from '@/common/hooks/useData';
import { useGlobal } from '@/common/context/GlobalProvider';

const TagsAddScreen = () => {
  const formRef: MutableRefObject<any> = useRef();
  const navigate = useNavigate();
  const { fetchTags } = useData();
  const { contextLoader, setContextLoader } = useGlobal();

  return (
    <Screen
      screenContainerClassName='bg-black'
      screenOptions={{
        header: {
          title: 'Add tag',
          backBtnLabel: 'Tags',
          backBtnUrl: '/tags',
          titleClassName: 'text-white',
        },
      }}
      className='px-4 grid grid-rows-5'
    >
      <FormFactory className='row-span-4' formRef={formRef} initialValues={{ name: '' }}>
        <Field name='name' placeholder='Tag name' component={Input} />
      </FormFactory>
      <div className='flex items-end'>
        <Button
          onClick={() => {
            setContextLoader(true);
            TagsService.create(formRef.current.values).then((res: any) => {
              setContextLoader(false);
              if (res?.success) {
                fetchTags();
                navigate('/tags');
              }
            });
          }}
          className='w-full mt-4'
          isLoading={contextLoader}
        >
          Add tag
        </Button>
      </div>
    </Screen>
  );
};

export default TagsAddScreen;
